import React from 'react';
import OfferTable from '../../../generic-components/special-offer-tables/special-offer-table';
import R from 'ramda';
const isNilOrEmpty = R.either(R.isNil, R.isEmpty);

const EditOffer = ({
  offersOrExtras,
  onTextFieldChangeWithKeyPath,
  updateCellValueForOfferRates,
  productType,
  RatesFormAndTable,
  contractingPeriod,
}) => {
  if (!offersOrExtras.selectedId || isNilOrEmpty(offersOrExtras.list)) return <div/>;
  const selectedIndex = offersOrExtras.list.findIndex(o => o._id === offersOrExtras.selectedId);
  const nonStandardTemplateType = R.path(['list', selectedIndex, 'nonStandardTemplateType'], offersOrExtras) || RatesFormAndTable.nonStandardTemplateType;
  const rates = R.pathOr(0, ['list', selectedIndex, 'rates', 'length'], offersOrExtras) ? R.path(['list', selectedIndex, 'rates'], offersOrExtras) : RatesFormAndTable.rates;
  const updateTableCell = R.pathOr(0, ['list', selectedIndex, 'rates', 'length'], offersOrExtras) ? ({ value, row, column }) => {
    onTextFieldChangeWithKeyPath({ keyPath: ['offersOrExtras', 'list', selectedIndex, 'rates', row, column], value });
  } : updateCellValueForOfferRates;
  return (
    <div style={{ overflow: 'inherit', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
      <OfferTable
        {...R.omit(['list'], offersOrExtras)}
        {...R.pathOr({}, ['list', selectedIndex], offersOrExtras)}
        inEdit
        style={{ width: '100%', padding: '16px 24px 36px 0' }}
        rates={rates}
        nonStandardTemplateType={nonStandardTemplateType}
        productType={productType}
        updateTableCell={updateTableCell}
        contractingPeriod={contractingPeriod}
        updateFieldValue={(keyPath, value) => {
          if (keyPath[0] === 'isStayPay') {
            onTextFieldChangeWithKeyPath({
              keyPath: ['offersOrExtras', 'list', selectedIndex],
              value: {
                isStayPay: true,
                offerName: 'Stay Pay',
                daysOfWeek: [],
                stayPays: [{}],
                rate: null,
                rates: [],
                nonStandardTemplateType: '',
                discountType: null,
                amount: null,
                numberOfGuests: null,
                commissionPercentage: null,
              },
            });
          }
          else onTextFieldChangeWithKeyPath({ keyPath: R.concat(['offersOrExtras', 'list', selectedIndex], keyPath), value });
        }}
      />
    </div>
  );
};

export default EditOffer;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/special-offers/edit-offer.jsx